import React from 'react';
import { HowToOrder } from '../components/home/HowToOrder';

export function ContactUsPage() {
  return <HowToOrder />;
}
